<style scoped>
.v-application .text-h4 {
  font-family: "Prompt", sans-serif !important;
  font-size: 24px !important;
}
.text-spacing {
  letter-spacing: 0px !important;
}
.v-application .white {
  border: #ccd0d9 solid 1px !important;
}
input.mx-input {
  height: 40px !important;
}
</style>

<template>
  <v-container fluid>
    <v-layout class="d-flex justify-space-between">
      <div
        class="text-h4 font-weight-black primary--text text-spacing"
        color="blue"
      >
        ใบวางบิล / ใบแจ้งหนี้
      </div>
      <v-spacer></v-spacer>
      <v-btn color="success" elevation="0" dark @click="create_form()">
        <v-icon left>mdi-file-plus</v-icon>สร้างใบวางบิล / ใบแจ้งหนี้
      </v-btn>
    </v-layout>
    <v-divider class="my-2"></v-divider>
    <SearchBar :Page="'Bill'"></SearchBar>
    <v-layout
      v-resize="onResize"
      column
      class="pt-5 d-flex justify-space-between"
    >
      <v-data-table
        :headers="headers"
        :items="bill"
        :items-per-page="20"
        class="elevation-1"
        :search="search"
        @click:row="handleRowClick"
      >
        <!-- <template v-slot:item.create_date="{ item }">{{
            item.create_date | formatDate
          }}</template>
          <template v-slot:item.total_price="{ item }">{{
            item.total_price | delimeter
          }}</template>
          <template v-slot:item.detail="{ item }">
            <TableMenu :TableData="item" :Page="'Bill'"></TableMenu>
          </template> -->
        <template #item="{ item }">
          <tr>
            <td>
              <span>
                {{ item.CREATED_AT | formatDate }}
              </span>
            </td>
            <td>{{ item.BILL_ID }}</td>
            <td>
              <span style="font-weight: bold">{{ item.CUSTOMER_NAME }}</span>
              <p class="mb-n1 mt-1" style="font-size: 12px">
                {{ item.MEMO }}
              </p>
            </td>
            <td>{{ item.CT_REF }}</td>
            <td>{{ item.PAID_VAT | delimeter }}</td>
            <td>
              <DocStatus :TableData="item" :Page="'Bill'"></DocStatus>
            </td>

            <td>
              <TableMenu :TableData="item" :Page="'Bill'"></TableMenu>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-layout>
    <EmailModal ref="Bill_Mail" :Page="'Bill'"></EmailModal>
  </v-container>
</template>

<script>
import TableMenu from '../components/TableMenu'
import SearchBar from '../components/SearchBar'
import EmailModal from '../components/EmailModal'
import DocStatus from "../components/DocStatus";
import moment from 'moment'
import printJS from 'print-js'
import XLSX from "xlsx";
import { mapGetters, mapMutations, mapActions } from "vuex";
export default {
  name: "Bill",
  components: {
    TableMenu,
    SearchBar,
    EmailModal,
    DocStatus
  },
  data: () => ({
    passData: Array,
    search: "",
    headers: [
      {
        text: "วันที่",
        align: "start",
        sortable: false,
        value: "CREATED_AT",
      },
      { text: "เลขที่เอกสาร", value: "BILL_ID" },
      { text: "ชื่อลูกค้า/ชื่อโปรเจ็ค", value: "CUSTOMER_NAME" },
      { text: "รหัสอ้างอิง", value: "CT_REF" },
      { text: "ยอดรวมสุทธิ", value: "PAID_VAT" },
      { text: "สถานะ", value: "DOC_STATUS" },
      { text: "", value: "detail" },
    ],
    bill: [],
  }),
  created() {
    this.$store.commit('Quotation/SET_IS_EDIT', false)
  },
  computed: {
    ...mapGetters({
      GET_BL: "Bill/GET_BILL"
    })
  },
  mounted() {

    this.list_bill()
  },
  filters: {
    delimeter(data) {
      let y = parseFloat(data).toFixed(2)
      let x = y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      return x

    },
    formatDate(data) {
      return moment(data).format('DD-MM-YYYY')
    }
  },
  methods: {
    ...mapMutations({
      LOADER: "Drawer/SET_LOADER",
      SET_STEP: "Drawer/SET_STEP",
      EDIT_BL: "Bill/SET_IS_EDIT",
      B_SET: "Bill/SET_ELEMENT",
      SET_ALL_BL: "Bill/SET_ALL_ELEMENT",
      B_SPLITING: "Bill/SET_SPLITING",
      B_MERGE: "Bill/MERGE_ALL_ELEMENT",
      B_SET_PRODUCT: "Bill/SET_PRODUCT_LIST",
    }),
    handleRowClick(item) {
      //   this.$store.commit('Quotation/SET_IS_EDIT', true)
      //   this.$store.commit("Quotation/SET_ELEMENT", {
      //     key: "QUOTATION_ID",
      //     value: item.qt_id,
      //   });
      //   console.log(tbl_data.qt_id)
      //   this.$router.push({ path: '/form' })
    },
    list_bill(time, text) {
      let date_obj = {
        SE_DATE1: typeof (time) == 'undefined' ? null : time[0],
        SE_DATE2: typeof (time) == 'undefined' ? null : time[1],
      }
      this.$token_api
        .post("/list-bill", date_obj)
        .then((response) => {
          this.bill = response.data.data;
          this.search = text
        })
        .catch((err) => { });
    },
    edit_bill(tbl_data) {
      this.LOADER(true)
      this.$token_api
        .post("/get-bill-by-id", { BILL_ID: tbl_data.BILL_ID })
        .then((response) => {
          this.EDIT_BL(true)
          this.SET_STEP(2);
          let qt_data = response.data.data[0]
          if (tbl_data.SPLIT_PAY == 1) {
            this.B_SET({ key: "SPLIT_PAY", value: tbl_data.SPLIT_PAY });
            this.B_SET({ key: "QUOTATION_ID", value: qt_data.QUOTATION_ID });
            this.B_MERGE(qt_data);
            this.B_SET_PRODUCT(JSON.parse(qt_data.PRODUCT_LIST));
            this.$router.push({ path: "/form" });
            this.LOADER(false);
            if (qt_data.SPLIT_OPTION) {
              if (qt_data) {

                // this.B_SPLITING(true)

                this.B_SET({ key: "TEMP_PREVIOUS_VALUE", value: qt_data.SPLIT_VALUE });
                this.B_SET({ key: "PREVIOUS_VALUE", value: qt_data.PREVIOUS_VALUE });
                this.B_SET({ key: "SPLIT_OPTION", value: qt_data.SPLIT_OPTION });
                this.B_SET({ key: "SPLIT_VALUE", value: qt_data.SPLIT_VALUE });
                this.B_SET({ key: "SPLIT_PAY", value: tbl_data.SPLIT_PAY });


              } else {
                this.LOADER(false);
              }
            } else {
              this.B_SPLITING(false)
            }
          } else {
            this.B_SET({ key: "QUOTATION_ID", value: qt_data.QUOTATION_ID });
            this.B_MERGE(qt_data);
            this.B_SET_PRODUCT(JSON.parse(qt_data.PRODUCT_LIST));
            this.$router.push({ path: "/form" });
            this.LOADER(false);
          }


        })
        .catch((err) => {
          this.LOADER(false)
        });
    },
    send_email(tbl_data) {
      this.$refs.Bill_Mail.openModal(tbl_data)
    },
    download_bill(tbl_data) {
      this.LOADER(true)
      this.$download_api.get(`/donwload-bill/${tbl_data.BILL_ID}`).then((response) => {

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'ใบวางบิล-แจ้งหนี้_' + tbl_data.BILL_ID + '.pdf');
        document.body.appendChild(link);
        link.click();
        this.LOADER(false)
      }).catch((err) => {
        this.$swal({
          title: "เกิดข้อผิดพลาด",
          icon: "warning",
          text: "ไม่พบเอกสารกรุณาเข้าไปบันทึกใหม่อีกครั้ง",
        })
        this.LOADER(false)
      });
    },
    print_bill(tbl_data) {
      this.LOADER(true)
      this.$download_api.get(`/donwload-bill/${tbl_data.BILL_ID}`).then((response) => {

        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(response.data, 'ใบวางบิล-แจ้งหนี้_' + tbl_data.BILL_ID + '.pdf'); //IE is the worst!!!
        } else {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          printJS(url)
        }
        this.LOADER(false)
      }).catch((err) => {
        this.$swal({
          title: "เกิดข้อผิดพลาด",
          icon: "warning",
          text: "ไม่พบเอกสารกรุณาเข้าไปบันทึกใหม่อีกครั้ง",
        })
        this.LOADER(false)
      });
    },
    remove_bill(tbl_data) {
      this.$swal({
        title: "ต้องการลบข้อมูลหรือไม่",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
      })
        .then((result) => {
          if (result.value) {
            // console.log(tbl_data.qt_id);
            this.$token_api
              .delete("/delete-bill", {
                data: {
                  BILL_ID: tbl_data.BILL_ID,
                }
              })
              .then((response) => {
                this.list_bill()
              })
              .catch((err) => { });
          }
        });
    },
    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    },
    create_form() {
      this.SET_STEP(2)
      this.B_SET({ key: "IS_CONTRACT", value: 2 })
      this.$router.push({ path: "/form" });
    },
    export_bill(time, text) {
      let date_obj = {
        SE_DATE1: typeof (time) == 'undefined' ? null : time[0],
        SE_DATE2: typeof (time) == 'undefined' ? null : time[1],
      }
      let xls_json = []
      this.$token_api
        .post("/list-bill", date_obj)
        .then((response) => {
          response.data.data.forEach((element) => {
            xls_json.push({
              'วันที่เอกสาร': moment(element.CREATED_AT).format('DD-MM-YYYY'),
              'เลขที่เอกสาร': element.BILL_ID,
              'ชื่อลูกค้า/ชื่อโปรเจค': element.CUSTOMER_NAME,
              'ยอดรวมสุทธิ': element.PAID_VAT
            });
          });
          const dataWS = XLSX.utils.json_to_sheet(xls_json);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, dataWS);
          XLSX.writeFile(wb, "ข้อมูลใบวางบิล-แจ้งหนี้.xlsx");
        })
        .catch((err) => {
          this.$swal({
            title: "เกิดช้อผิดพลาด",
            icon: "warning",
            text: `เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง\n${err}`,
            timer: 2000
          })
        });
    }
  },

};
</script>
